








import Vue from "vue"
export default Vue.extend({
  props: {
    isShown: {
      type: Boolean,
      required: true,
    },
  },
})
